import { render, staticRenderFns } from "./emailpage.vue?vue&type=template&id=5af7aa58&scoped=true&"
import script from "./emailpage.vue?vue&type=script&lang=js&"
export * from "./emailpage.vue?vue&type=script&lang=js&"
import style0 from "./emailpage.vue?vue&type=style&index=0&id=5af7aa58&prod&scoped=true&lang=css&"
import style1 from "./emailpage.vue?vue&type=style&index=1&id=5af7aa58&prod&lang=css&"
import style2 from "./emailpage.vue?vue&type=style&index=2&id=5af7aa58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af7aa58",
  null
  
)

export default component.exports